const colorLabelSortOrder = [
  "#46CD24",
  "#FFE500",
  "#FF0000",
  "#0047FF",
  "#C72AEE"
];
const sortColorLabels = (colors) => {
  return colors.slice(0).sort((a, b) => {
    const aIndex = colorLabelSortOrder.indexOf(a.hexColor);
    const bIndex = colorLabelSortOrder.indexOf(b.hexColor);
    if (aIndex === -1 && bIndex === -1) return 0;
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });
};

export { sortColorLabels };
//# sourceMappingURL=labels.utils.js.map
